import React, { useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { Theme } from '@constants';

import mapboxLogo from '../../assets/map/mapbox_logo.png';
import { isWeb } from '../../helpers/Platform';
import { TWCText } from '../primitives/TWCText/TWCText';

export const MapAttribution = ({ style }) => {
  // Our View's height.
  const [viewHeight, setViewHeight] = useState(0);

  // The size of the logo image.
  const [logoWidth, setLogoWidth] = useState(267);
  const [logoHeight, setLogoHeight] = useState(60);

  if (isWeb) {
    Image.getSize(mapboxLogo, (width, height) => {
      if (width !== logoWidth) {
        setLogoWidth(width);
      }
      if (height !== logoHeight) {
        setLogoHeight(height);
      }
    });
  } else {
    const size = Image.resolveAssetSource(mapboxLogo);

    if (size.width !== logoWidth) {
      setLogoWidth(size.width);
    }
    if (size.height !== logoHeight) {
      setLogoHeight(size.height);
    }
  }

  // The display size of the logo.
  let displayWidth = Theme.px(0);
  let displayHeight = Theme.px(0);

  if (logoHeight > 0 && logoWidth > 0 && viewHeight > 0) {
    displayWidth = (viewHeight / logoHeight) * logoWidth;
    displayHeight = viewHeight;
  }

  return (
    <View
      style={[style, styles.container]}
      onLayout={event => {
        const { height } = event.nativeEvent.layout;

        if (height != null && height !== viewHeight) {
          setViewHeight(height);
        }
      }}
    >
      <Image
        source={mapboxLogo}
        style={[
          styles.mapboxLogo,
          {
            height: displayHeight,
            width: displayWidth,
          },
        ]}
      />
      <TWCText noTestID style={styles.copyright} variant={'regularText20'}>
        {'© Mapbox, © OpenStreetMap'}
      </TWCText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  copyright: {
    textShadowColor: Theme.black,
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  mapboxLogo: {
    resizeMode: 'contain',
  },
});
